import { render, staticRenderFns } from "./upload-new-userinfo.vue?vue&type=template&id=18ac8f20&scoped=true&"
import script from "./upload-new-userinfo.vue?vue&type=script&lang=js&"
export * from "./upload-new-userinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac8f20",
  null
  
)

export default component.exports